(() => {
  const script = document.currentScript;
  const label = script?.dataset.lengthLabel || 'Length';
  const selector = '[data-piral-length-label]';
  const update = element => {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const next = node.nodeValue.replace(/\binseam\b/gi, label);
      if (next !== node.nodeValue) node.nodeValue = next;
    }
  };
  const scan = node => {
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    if (node.matches(selector)) update(node);
    node.querySelectorAll(selector).forEach(update);
  };
  scan(document.body);
  new MutationObserver(records => {
    const targets = new Set();
    records.forEach(record => {
      const element = record.target.nodeType === Node.TEXT_NODE
        ? record.target.parentElement : record.target;
      const target = element?.closest?.(selector);
      if (target) targets.add(target);
      record.addedNodes.forEach(scan);
    });
    targets.forEach(update);
  }).observe(document.body, { childList: true, characterData: true, subtree: true });
})();
